import { NumberingFormat } from '../../core/model/numbering-lists/list-level-properties';
export const RtfNumberingFormats = [
    NumberingFormat.Decimal,
    NumberingFormat.UpperRoman,
    NumberingFormat.LowerRoman,
    NumberingFormat.UpperLetter,
    NumberingFormat.LowerLetter,
    NumberingFormat.Ordinal,
    NumberingFormat.CardinalText,
    NumberingFormat.OrdinalText,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.AIUEOHiragana,
    NumberingFormat.Iroha,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.DecimalEnclosedCircle,
    NumberingFormat.None,
    NumberingFormat.AIUEOFullWidthHiragana,
    NumberingFormat.IrohaFullWidth,
    NumberingFormat.DecimalZero,
    NumberingFormat.Bullet,
    NumberingFormat.Ganada,
    NumberingFormat.Chosung,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.KoreanCounting,
    NumberingFormat.KoreanDigital,
    NumberingFormat.KoreanDigital2,
    NumberingFormat.KoreanLegal,
    NumberingFormat.Hebrew1,
    NumberingFormat.ArabicAlpha,
    NumberingFormat.Hebrew2,
    NumberingFormat.ArabicAbjad,
    NumberingFormat.HindiVowels,
    NumberingFormat.HindiConsonants,
    NumberingFormat.HindiNumbers,
    NumberingFormat.HindiDescriptive,
    NumberingFormat.ThaiLetters,
    NumberingFormat.ThaiNumbers,
    NumberingFormat.ThaiDescriptive,
    NumberingFormat.VietnameseDescriptive,
    NumberingFormat.NumberInDash,
    NumberingFormat.RussianLower,
    NumberingFormat.RussianUpper,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
    NumberingFormat.None,
];
